export default __webpack_public_path__ + "static/villa3-92006ebb5913d1529becf0ba5269519f.jpeg";